import { CommonModule } from '@angular/common';
import { inject, InjectionToken, NgModule } from '@angular/core';

import { PriceListComponent } from '../../components/price-list/price-list.component';
import { PopupService } from '../../shared/services/popup.service';
import { SharedModule } from '../../shared/shared.module';
import { HolidaysDatesBatchActionsComponent } from './components/holidays-dates-batch-actions/holidays-dates-batch-actions.component';
import { HolidaysDatesFormComponent } from './components/holidays-dates-form/holidays-dates-form.component';
import { HolidaysDatesRowComponent } from './components/holidays-dates-row/holidays-dates-row.component';
import { OrganisationFormComponent } from './components/organisation-form/organisation-form.component';
import { SettingsPopupComponent } from './components/settings-popup/settings-popup.component';
import { TrafficFormComponent } from './components/traffic-form/traffic-form.component';
import { UsersComponent } from './components/user/users.component';
import { UserFilterComponent } from './components/user-filter/user-filter.component';
import { UserRowComponent } from './components/user-row/user-row.component';
import { WorkplaceFormComponent } from './components/workplace-form/workplace-form.component';
import { AddUserComponent } from './pages/add-user/add-user.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { CreateHolidaysDatesComponent } from './pages/create-holidays-dates/create-holidays-dates.component';
import { EditHolidaysDatesComponent } from './pages/edit-holidays-dates/edit-holidays-dates.component';
import { EditUserComponent } from './pages/edit-user/edit-user.component';
import { HolidaysDatesComponent } from './pages/holidays-dates/holidays-dates.component';
import { InviteUsersComponent } from './pages/invite-users/invite-users.component';
import { KindergartenDataComponent } from './pages/kindergarten-data/kindergarten-data.component';
import { OrganizationWorkplaceItemComponent } from './pages/organization-workplaces/organization-workplace-item/organization-workplace-item.component';
import { OrganizationWorkplacesComponent } from './pages/organization-workplaces/organization-workplaces.component';
import { SettingsRoutingModule } from './settings-routing.module';

export const SETTINGS_MODULE_ROOT_URL = new InjectionToken<string>('SETTINGS_MODULE_ROOT_URL');

@NgModule({
  imports: [CommonModule, SharedModule, SettingsRoutingModule],
  declarations: [
    KindergartenDataComponent,
    OrganizationWorkplacesComponent,
    WorkplaceFormComponent,
    OrganisationFormComponent,
    TrafficFormComponent,
    HolidaysDatesComponent,
    HolidaysDatesRowComponent,
    HolidaysDatesBatchActionsComponent,
    HolidaysDatesFormComponent,
    CreateHolidaysDatesComponent,
    EditHolidaysDatesComponent,
    PriceListComponent,
    ChangePasswordComponent,
    UsersComponent,
    UserFilterComponent,
    UserRowComponent,
    AddUserComponent,
    EditUserComponent,
    InviteUsersComponent,
    SettingsPopupComponent,
    OrganizationWorkplaceItemComponent,
  ],
  providers: [],
})
export class SettingsModule {
  private readonly popupService = inject(PopupService);
  private readonly rootUrl = inject(SETTINGS_MODULE_ROOT_URL);
  constructor() {
    this.popupService.manageModulePopup(this.rootUrl).subscribe((conf) => {
      if (conf.allow) {
        this.popupService.tryShowPopup('m_app_settings');
      }
    });
  }
}
